// extracted by mini-css-extract-plugin
module.exports = {"headButton":"style_headButton__2V3kW","section":"style_section__2P0-6","searchBox":"style_searchBox__3aRBX","headButtonIcon":"style_headButtonIcon__3Gpa5"};